export function toInitials(fullName: string) {
  if (!fullName) {
    return ''
  }
  const initials = fullName
    .replace(/[^A-Za-z0-9À-ÿ ]/gi, '') // take care of accented characters
    .replace(/ +/gi, ' ') // replace multiple spaces to one
    .split(/ /) // break the name into parts
    .reduce((acc, item) => acc + item[0], '') // assemble an abbreviation from the parts
    .concat(fullName.substring(1)) // in case the name consists of only one part
    .concat(fullName) // in case name is only one character
    .substring(0, 2) // get the first two characters
    .toUpperCase()

  return initials
}
